var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 24c-1.9 0-3.6-.7-4.9-2-1.4-1.3-2.1-3.1-2.1-4.9s.7-3.6 2-4.9l2.5-2.5 1.4 1.4-2.5 2.5c-.9.9-1.4 2.2-1.4 3.5s.5 2.6 1.4 3.5c1 1 2.2 1.5 3.5 1.5s2.6-.5 3.5-1.4l2.6-2.6 1.4 1.4-2.5 2.5c-1.3 1.3-3.1 2-4.9 2zm11.2-3.2-15.9-15.9 1.4-1.4 3.5 3.5 5.5-5.5c.8-.9 2.1-1.5 3.4-1.5 1.3 0 2.6.5 3.5 1.5 1 1 1.5 2.2 1.5 3.6 0 1.3-.5 2.6-1.5 3.5l-5.5 5.4 1.4 1.4 4.4-4.3 1.4 1.4-4.3 4.3 2.6 2.6zm-6.8-9.6 1.4 1.4 5.5-5.5c.6-.6.9-1.3.9-2.1s-.3-1.5-.9-2.1c-.7-.6-1.5-.9-2.2-.9-.8 0-1.5.3-2.1.9l-5.4 5.5 1.4 1.4 4.3-4.3 1.4 1.4zm-4.4 8.8c-.8 0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1.3-1.5.9-2.1l2.5-2.5 1.4 1.4-2.5 2.5c-.2.2-.3.4-.3.7s.1.5.3.7c.4.4 1 .4 1.4 0l2.5-2.5 1.4 1.4-2.5 2.5c-.6.6-1.4.9-2.1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetach);
export default __webpack_public_path__ + "static/media/detach.187cb63451cd6a13cfdd5bea942d6fea.svg";
export { ForwardRef as ReactComponent };